<template>
  <div class="echarts">
    <IEcharts :option="chartOptions" :loading="loading" @ready="onReady" @click="onClick" />
  </div>
</template>

<script>
import IEcharts from "vue-echarts-v3/src/full.js";
import { HTTP as IOTHTTP } from "../../../../store/actions";
import moment from "moment";

export default {
  name: "custom-chart",
  components: {
    IEcharts
  },
  props: ["data", "loading","orient"],
  watch: {
    // watch it
    data: function(newVal, oldVal) {
      this.chartOptions.series[0].data = newVal.data;
      this.chartOptions.series[0].name = "";
      this.chartOptions.title.text = newVal.title ? newVal.title : "no title";
      this.chartOptions.legend.orient  = newVal.orient ? newVal.orient : "vertical";
      this.chartOptions.legend.data = this.computeLegendValues(newVal.data);
    }
  },
  data: () => ({
    // initOpts: {
    //   renderer: 'svg'
    // },
    chartOptions: {
      title: {
        text: "",
        bottom: "center",
        left: "center",
        fontSize: 15
      },
      tooltip: {
        trigger: "item",
        axisPointer: {
          type: "shadow"
        },
        formatter: "{a} <br/>{b}: {c}kW ({d}%)"
      },
      legend: {
        orient: "vertical",
        left: 10,
        data: []
      },
      series: [
        {
          name: null,
          type: "pie",
          radius: ["50%", "70%"],
          avoidLabelOverlap: false,
          label: {
            show: false,
            position: "center"
          },
          emphasis: {
            label: {
              show: false,
              fontSize: "20",
              fontWeight: "bold"
            }
          },
          labelLine: {
            show: false
          },
          data: []
        }
      ]
    }
  }),
  methods: {
    onClick(event, instance, ECharts) {
      console.log(arguments);
    },
    async onReady(instance, ECharts) {
      this.$emit("onReady");
    },
    computeLegendValues(arr) {
      if (!Array.isArray(arr)) return [];
      return arr.map(item => {
        return item.name;
      });
    }
  },
  mounted() {}
};
</script>

<style scoped>
.echarts {
  margin-top: 20px;
  height: 400px;
  min-width: 400px;
  max-width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/dashboard/components/customPieChart.vue